var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceOfBirthCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 22,
    viewBox: "0 0 21 22",
    width: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.1686 13.7656h2.1954c.7534 0 1.4219.4821 1.6599 1.197l.5836 1.75c.378 1.1331-.4655 2.303-1.6599 2.303h-10.89373c-1.19438 0-2.03788-1.1699-1.65988-2.303l.58363-1.75c.23712-.7149.9065-1.197 1.65987-1.197h2.19625",
    stroke: "#3158f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "m10.5 16.3906s-5.25-4.193-5.25-8.0211c0-2.81837 2.35025-5.10388 5.25-5.10388 2.8997 0 5.25 2.28551 5.25 5.10388 0 3.8281-5.25 8.0211-5.25 8.0211z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#3158f2",
      stroke: "#3158f2",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m11.7374 7.27794c.6835.68342.6835 1.79146 0 2.47488-.6834.68338-1.79142.68338-2.47484 0-.68341-.68342-.68341-1.79146 0-2.47488.68342-.68341 1.79144-.68341 2.47484 0z",
    fill: "#e4e7ec",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m11.7374 7.27794c.6835.68342.6835 1.79146 0 2.47488-.6834.68338-1.79142.68338-2.47484 0-.68341-.68342-.68341-1.79146 0-2.47488.68342-.68341 1.79144-.68341 2.47484 0",
    stroke: "#e4e7ec",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.875
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceOfBirthCheck);
export default __webpack_public_path__ + "static/media/place_of_birth_check.ce7e3085e391e6225517e09c0b5dc145.svg";
export { ForwardRef as ReactComponent };